import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import { SimplifiedSidebar } from './SimplifiedSidebar';
import Header from './Header';
export function Layout({
  simplified = false
}) {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const handleMenuClick = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  const handleCloseSidebar = () => {
    setIsSidebarOpen(false);
  };
  return <div className="flex h-screen bg-gray-50" data-id="element-366">
      {simplified ? <SimplifiedSidebar isOpen={isSidebarOpen} onClose={handleCloseSidebar} data-id="element-367" /> : <Sidebar isOpen={isSidebarOpen} onClose={handleCloseSidebar} data-id="element-368" />}
      <div className="flex-1 flex flex-col overflow-hidden" data-id="element-369">
        <Header onMenuClick={handleMenuClick} data-id="element-370" />
        <main className="flex-1 overflow-auto p-4 md:p-6" data-id="element-371">
          <Outlet data-id="element-372" />
        </main>
      </div>
    </div>;
}
export default Layout;